import type { DBTable } from '@analytical-alley/duckdb-react/types';
import { z } from 'zod';

export const modelContributionsSchema = z.object({
    execution_id: z.string(),
    Product: z.string(),
    Market: z.string(),
    'Period name': z.string(),
    Variable: z.string(),
    Category: z.string(),
    Contribution: z.number(),
    Spend: z.number(),
    Cost: z.number(),
    Actual: z.number(),
    Raw: z.number(),
    Transformed: z.number(),
});

export const modelContributionsColumnMap = {
    execution_id: 'executionId',
    Product: 'product',
    Market: 'market',
    'Period name': 'periodName',
    Variable: 'variable',
    Category: 'category',
    Contribution: 'contribution',
    Spend: 'spend',
    Cost: 'cost',
    Actual: 'actual',
    Raw: 'raw',
    Transformed: 'transformed',
} as const;

type SchemaType = z.infer<typeof modelContributionsSchema>;

export type TModelContributionRow = DBTable<
    SchemaType,
    typeof modelContributionsColumnMap
>;
